import { createSlice } from '@reduxjs/toolkit';

const brandSlice = createSlice({
  name: 'brand',
  initialState: { brand: {
    name: '',
    brandowner_id: 0,
    brandowner: null,
    description: '',
    images: [],
    is_favorite: false,
    is_blacklisted: false,
  } },
  reducers: {
    setBrand: (state, action) => {
        const updates = action.payload; // Destructure updates from the action payload.

        // Parse country
        try {
          updates.country = JSON.parse(updates.country)
        } catch (error) {
          // 
        }

        // Parse market data
        try {
          updates.market = JSON.parse(updates.market)
        } catch (error) {
          // 
        }
        
        state.brand = { ...state.brand, ...updates }; // Merge the updates into the state
    },
    setIsBlacklisted: ( state, action ) => {
      console.log(action.payload);
      state.brand = { ...state.brand, ...action.payload }
    },
    setIsFavorite: (state, action) => {
      state.brand.is_favorite = action.payload;
    }
  },
});

export const { setBrand, setIsBlacklisted, setIsFavorite } = brandSlice.actions;

export default brandSlice.reducer;